// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"8d12513b","131":"af4e81a0","149":"bdf02b08","170":"c4078e8e","453":"ba5fb8b4","723":"5778f369","743":"e0920a55","874":"9d7a7592"}[chunkId] + ".chunk.js";
};